import appConfig from '@/config/appConfig.typed';

import DcxTopBanner from './DcxTopBanner/DcxTopBanner';
import HomePageTopBanner from './HomePageTopBanner/HomePageTopBanner';

const TopBanner = ({id}) => {
    const isDcxLoyaltyEnabled = appConfig.getIsDcxLoyaltyEnabled();

    return isDcxLoyaltyEnabled ? <DcxTopBanner id={id} /> : <HomePageTopBanner id={id} />;
};

export default TopBanner;
